/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type DesignServiceBanner_user$ref = any;
type FolderContainer_viewer$ref = any;
type FoldersContainer_viewer$ref = any;
type FollowingContainer_viewer$ref = any;
type ItemsContainer_viewer$ref = any;
type ProjectsContainer_viewer$ref = any;
type Recommendations_trending$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type FavoritesContainer_viewer$ref: FragmentReference;
export type FavoritesContainer_viewer = {|
  +user?: ?{|
    +isVerifiedTrade: ?boolean,
    +canShowSellerName: ?boolean,
    +$fragmentRefs: DesignServiceBanner_user$ref,
  |},
  +$fragmentRefs: Recommendations_trending$ref & FolderContainer_viewer$ref & FoldersContainer_viewer$ref & FollowingContainer_viewer$ref & ItemsContainer_viewer$ref & ProjectsContainer_viewer$ref,
  +$refType: FavoritesContainer_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "FavoritesContainer_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "hasUserId",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "isSinglePortfolio",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "isFolders",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "isFollowing",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "isItems",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "isProjects",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isProjects",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "ProjectsContainer_viewer",
          "args": null
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isItems",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "ItemsContainer_viewer",
          "args": null
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isFollowing",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "FollowingContainer_viewer",
          "args": null
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isFolders",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "FoldersContainer_viewer",
          "args": null
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isSinglePortfolio",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "FolderContainer_viewer",
          "args": null
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": false,
      "condition": "hasUserId",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "Recommendations_trending",
          "args": null
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasUserId",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId",
              "type": "String!"
            }
          ],
          "concreteType": "User",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "DesignServiceBanner_user",
              "args": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "isVerifiedTrade",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "canShowSellerName",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '9092e62beab1b0f9fca076a04a2b2315';
module.exports = node;
